module.exports = __webpack_public_path__ + "static/Select-30481b4bb012d8f6ddab6e85e42acbc2.svg";